/**
 * Распределение ширины sticky-колонок (~1/3 viewport) с минимумами.
 */

export const STRATEGIC_MAP_STICKY_WEIGHTS = {
  index: 56,
  project: 160,
  status: 160,
  sections: 70,
  area: 100,
  duration: 80,
  move: 64,
};

export const STRATEGIC_MAP_STICKY_MINS = {
  index: 44,
  project: 100,
  status: 90,
  sections: 56,
  area: 72,
  duration: 56,
  move: 52,
};

/**
 * @param {number} containerWidth
 * @param {Record<string, number>} weights
 * @param {Record<string, number>} mins
 * @param {number} [fraction=1/3]
 * @returns {Record<string, number>}
 */
export function computeStickyColumnWidths(
  containerWidth,
  weights = STRATEGIC_MAP_STICKY_WEIGHTS,
  mins = STRATEGIC_MAP_STICKY_MINS,
  fraction = 1 / 3
) {
  const keys = Object.keys(weights);
  const minTotal = keys.reduce((sum, key) => sum + (mins[key] ?? 0), 0);
  const weightTotal = keys.reduce((sum, key) => sum + weights[key], 0) || 1;
  const width = Math.max(0, Number(containerWidth) || 0);
  const budget = Math.max(minTotal, Math.round(width * fraction));

  if (budget <= minTotal) {
    const exact = {};
    keys.forEach((key) => {
      exact[key] = mins[key] ?? 0;
    });
    return exact;
  }

  const remaining = budget - minTotal;
  const result = {};
  let usedExtra = 0;
  keys.forEach((key, idx) => {
    if (idx === keys.length - 1) {
      result[key] = (mins[key] ?? 0) + (remaining - usedExtra);
      return;
    }
    const extra = Math.round((weights[key] / weightTotal) * remaining);
    result[key] = (mins[key] ?? 0) + extra;
    usedExtra += extra;
  });

  return result;
}

/**
 * @param {Record<string, number>} widths
 * @returns {Record<string, number>}
 */
export function computeStickyColumnOffsets(widths) {
  const order = ['index', 'project', 'status', 'sections', 'area', 'duration', 'move'];
  const offsets = {};
  let left = 0;
  order.forEach((key) => {
    offsets[key] = left;
    left += widths[key] || 0;
  });
  return offsets;
}

/**
 * @param {Record<string, number>} widths
 * @returns {number}
 */
export function sumStickyColumnWidths(widths) {
  return Object.values(widths || {}).reduce((sum, value) => sum + (Number(value) || 0), 0);
}
